import { Component, inject } from '@angular/core';
import { ICON } from '@core/util/icon';
import { base64 } from '@core/util/file';
import { DrawerService } from '../../../ui/drawer/drawer.service';
import { DRAWER_DATA } from '../../../ui/drawer/drawer-data.token';
import { dispatch } from '@ngxs/store';
import { Delete } from '@state/matter/uploaded-files/matter-uploaded-files.actions';

export interface PdfModalData {
	googleSrcUrl?: string;
	base64Encoded?: base64;
	fileName?: string;
	showDelete?: boolean;
	fileId?: string;
	url?: string;
	blob?: Blob;
	fileType?: string;
}

@Component({
	selector: 'app-pdf-modal',
	templateUrl: './pdf-modal.component.html',
	standalone: false,
})
export class PdfModalComponent {
	public base64Encoded = null;
	public googleSrcUrl = null;
	public showDelete = false;
	public ICON = ICON;
	public ready = false;
	public fileName: string;
	public fileId: string;
	public url: string;
	public fileType: string;
	public blob: Blob;
	private drawerService = inject(DrawerService);
	private data: PdfModalData = inject(DRAWER_DATA);
	private deleteMatterUploadedFile = dispatch(Delete);

	constructor() {
		if (this.data?.googleSrcUrl) {
			this.googleSrcUrl = this.data.googleSrcUrl;
		}
		if (this.data?.url) {
			this.url = this.data.url;
		}

		if (this.data?.showDelete) {
			this.showDelete = this.data.showDelete;
		}

		if (this.data?.base64Encoded) {
			this.base64Encoded = this.data.base64Encoded;
		}

		if (this.data?.fileId) {
			this.fileId = this.data?.fileId;
		}

		if (this.data?.fileType) {
			this.fileType = this.data.fileType;
		}

		if (this.data?.blob) {
			this.blob = this.data.blob;
		}

		this.fileName = this.data?.fileName;
	}

	delete() {
		if (this.fileId) {
			this.deleteMatterUploadedFile(this.fileId);
			this.close();
		}
	}

	close() {
		this.drawerService.closeDrawer();
	}
}
